module.exports = __webpack_public_path__ + "media/images/athletes/1328-7d4007a9885d0e333a34207aa04447ab.png";